export enum Permission {
  ASSET_FINDER = 'ASSET_FINDER',
  TRAY_ASSEMBLER = 'TRAY_ASSEMBLER',
  OR_ASSIGN = 'OR_ASSIGN',
  SPD_RELEASE = 'SPD_RELEASE',
  ADMIN = 'ADMIN',
}

export interface AnalyticsUser {
  id: string;
  email?: string; // SHA256 hashed before sending — sourced from user.username (Zitadel email)
  permissions: Permission[];
  sessionKey: string | null;
}

export interface AnalyticsContext {
  gtmContainerId: string;
  ga4MeasurementId: string;
  environment: string;
  appName: string;
  hospital: string;
  tenantName?: string; // raw hospital/tenant name — SHA256 hashed before pushing to GA4
}

export interface UserAnalyticsProperties {
  user_id: string;
  user_role: string | null;
  app_session_id: string;
}

export interface CustomEvent {
  event: string;
  [key: string]: unknown;
}

export interface TrayEventDimensions {
  tray_name?: string;
  tray_ID?: string;
  instrument_ID?: string;
  tray_progress?: string;
  child_view?: string;
  modal?: string;
}
